import {AnyElement, IMuWidget} from "./IMuWidget";
import {stringify} from "json5";

export class SearchSelector extends IMuWidget {

	constructor(el : AnyElement) {
		super();
		el.innerHTML =
			'<ul mu-id="lSelected" mu-bind="selected:@foreach" class="search-selector-selected">\n' +
			'    <li mu-template="itemSelected" mu-widget="SearchSelectorItemSelected">\n' +
			'        <span mu-id="name" mu-bind="id::@attr.id;name"></span>\n' +
			'    </li>\n' +
			'</ul>\n' +
			'<div class="input-group">\n' +
			'    <input type="text" class="form-control" mu-id="cTerm" />\n' +
			'    <div class="input-group-addon">\n' +
			'        <div class="input-group-text">\n' +
			'            <span class="icon-erase" mu-id="cleanSearch"></span>\n' +
			'        </div>\n' +
			'    </div>\n' +
			'</div>\n' +
			'<ul mu-id="lSearchResults" mu-bind="searchResults:@foreach" class="search-selector-search-results">\n' +
			'    <li mu-template="itemSearched" mu-widget="SearchSelectorItemSearched">\n' +
			'        <span mu-id="name" mu-bind="id::@attr.id;name::text"></span>\n' +
			'    </li>\n' +
			'</ul>\n';
		el.classList.add("search-selector");
	}

	afterIndex() {
		this.muRegisterEvent("itemAdded");
		if (!this.layout) this.layout = "MultiSelected";
		this.setLayout(this.layout);
	}

	public searchCallback : (term : string|string[]|number[], resolve: (res : SearchSelectorItem[]) => void) => void;

	public searchPromiseCallback : (term : string|string[]|number[]) => Promise<any>;

	private lastKeyPress: Date;

	public searchAfterSec : number = 1;

	public minTermLength : number = 3;

	override muFetchData(): string[] {
		return this.muGetChildWidgets<SearchSelectorItemSelected>("lSelected")
			.map(isw => isw.getId());
	}

	public cTerm_keypress() {
		this.lastKeyPress = new Date();
		// console.count("keypress");
		setTimeout(() => {
			// console.count("keypress on timer");
			const term = (this.ui.cTerm as HTMLInputElement).value.trim();
			if (term.length < this.minTermLength) return;
			const now = new Date();
			const diff = (now.getTime() - this.lastKeyPress.getTime()) / 1000;
			if (diff > this.searchAfterSec) {
				// console.count("loading");
				this.doCallSearch(term);
				this.lastKeyPress = new Date();
			}
		}, (this.searchAfterSec + 0.1) * 1000)
	}

	private doCallSearch(term: string|string[]|number[], callback: ((items: SearchSelectorItem[]) => void) = null) {
		if (!term) return;
		const fillData = items => {
			this.muBindData({ searchResults: items });
			if (callback) callback(items);
		};
		if (this.searchPromiseCallback)
			this.searchPromiseCallback(term).then(fillData);
		else if (this.searchCallback)
			this.searchCallback(term, fillData);
		else throw "SearchSelector: search(Promise)Callback is not defined";
	}

	public addSelected(item: SearchSelectorItem) {
		if (this.layout == "SingleSelected") this.ui.lSelected.innerHTML = "";
		if (this.layout != "NoSelected") this.muWidgetFromTemplate("itemSelected", "lSelected").muBindData(item);
		this.muDispatchEvent("itemAdded", item);
	}

	public cleanSearch_click() {
		this.ui.cTerm.value = "";
		this.muBindData({ searchResults: [] });
	}

	public setLayout(layout: SearchSelectorLayout) {
		this.layout = layout;
		this.muVisible(layout !== "NoSelected", "lSelected");
	}

	public layout : SearchSelectorLayout|null;

	/* public muBindData(srcData: any) {
	} */

	getValue(): string[] {
		return this.muGetChildWidgets<SearchSelectorItemSelected>("lSelected")
			.map(isw => isw.getId());
	}

	setValue(value: number[]|SearchSelectorItem[]) {
		this.clearValue();
		if (value.length && typeof value[0] === "object")
		{
			// this.muBindData({ searchResults: value });
			for(const item of value) this.addSelected(item);
		}
		else
		{
			const placeholders = value.map((id) => <SearchSelectorItem>{
				id: id,
				name: '...'
			});
			// this.muBindData({ searchResults: placeholders });
			for(const item of placeholders) this.addSelected(item);
			this.doCallSearch(value, items => items.forEach(item => this.addSelected(item)));
		}
	}

	muBindData(srcData: any) {
		if (Array.isArray(srcData))
			this.setValue(srcData);
		else super.muBindData(srcData);
	}

	public clearValue(): void {
		this.ui.lSelected.innerHTML = '';
	}
}

export type SearchSelectorItem = {
	name : string,
	id : number
}

export class SearchSelectorItemSelected extends IMuWidget {
	public name_click() {
		this.muRemoveSelf();
	}

	public getId() : string {
		return this.muFetchData().id;
	}
}

export class SearchSelectorItemSearched extends IMuWidget {
	public name_click() {
		(this.muParent as SearchSelector).addSelected(this.muFetchData() as SearchSelectorItem);
		this.muRemoveSelf();
	}
}

export type SearchSelectorLayout = "MultiSelected"|"SingleSelected"|"NoSelected";
